export const HTTP_STATUS_CODE_402_PAYMENT_REQUIRED = 402;
export const HTTP_STATUS_CODE_403_UNAUTHORIZED = 403;
